import request from '@/utils/request'

// 赛事相关接口
export function getGameList(params) {
  return request({
    url: '/api/game/list',
    method: 'get',
    params: {
      pageNum: params.pageNum,
      pageSize: params.pageSize,
      game_name: params.game_name,
      game_type: params.game_type,
      game_level: params.game_level,
      fix_status: params.fix_status,
      replay_status: params.replay_status,
      game_time_start: params.game_time_start,
      game_time_end: params.game_time_end,
      sort_prop: params.sort_prop,
      sort_order: params.sort_order
    }
  })
}

export function addGame(data) {
  return request({
    url: '/api/game/add',
    method: 'post',
    data: {
      ...data,
      game_time: data.game_time ? new Date(data.game_time).toISOString().split('T')[0] : undefined
    }
  })
}

export function updateGame(data) {
  return request({
    url: '/api/game/update',
    method: 'put',
    data: {
      ...data,
      game_time: data.game_time ? new Date(data.game_time).toISOString().split('T')[0] : undefined
    }
  })
}

export function deleteGame(id) {
  return request({
    url: `/api/game/${id}`,
    method: 'delete'
  })
}

export function batchDeleteGames(data) {
  return request({
    url: '/api/game/batch-delete',
    method: 'post',
    data
  })
}

// 统计相关接口
export function getGameStatistics(params = {}) {
  // 处理数组参数
  const processedParams = {
    ...params,
    game_types: Array.isArray(params.game_types) && params.game_types.length > 0 
      ? params.game_types.join(',') 
      : undefined,
    game_levels: Array.isArray(params.game_levels) && params.game_levels.length > 0
      ? params.game_levels.join(',') 
      : undefined
  }

  return request({
    url: '/api/game/statistics',
    method: 'get',
    params: processedParams
  })
}

// 添加获取过滤选项的函数
export function getFilterOptions() {
  return request({
    url: '/api/game/filter-options',
    method: 'get'
  })
}

// 保存复盘数据
export function saveGameReplay(data) {
  return request({
    url: '/api/replay/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    data
  })
}

// 获取复盘信息
export function getGameReplay(gameCode) {
  return request({
    url: `/api/replay/get/${gameCode}`,
    method: 'get'
  })
}

// 更新复盘信息
export function updateGameReplay(data) {
  return request({
    url: '/api/replay/update',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

// 删除复盘信息
export function deleteGameReplay(gameCode) {
  return request({
    url: `/api/replay/delete/${gameCode}`,
    method: 'delete'
  })
}

// 创建复盘记录
export function addGameReplay(data) {
  return request({
    url: '/api/replay/add',
    method: 'post',
    data: {
      game_code: data.game_code,
      global_replay: data.global_replay,
      questions: data.questions
    }
  })
}

// ... 其他API调用 